/** "2019 Ford F-150", from whichever of year, make and model are known. */
export function vehicleOf(
  vehicle:
    | {
        vehicleYear?: number | string | null;
        vehicleName?: string | null;
        vehicleMake?: string | null;
        vehicleModel?: string | null;
      }
    | null
    | undefined
): string | undefined {
  if (!vehicle) return undefined;
  return (
    [
      vehicle.vehicleYear,
      vehicle.vehicleMake ?? vehicle.vehicleName,
      vehicle.vehicleModel,
    ]
      .filter(Boolean)
      .join(' ') || undefined
  );
}
